import React, {Fragment, useContext, useEffect, useRef, useState} from 'react';
import Container from 'react-bootstrap/Container';
import {Col, Form, Row} from "react-bootstrap";
import {useNavigate} from "react-router-dom";
import {fetchToken} from "../../middleware/Firebase.js";
import {Button, Dialog, InputAdornment, ListItemButton, Slide, TextField} from "@mui/material";
import {base64toBlob, isIpad, isMac, isStandalone} from "../../service/UtilityService.js";
import {ClientJS} from 'clientjs';
import {makeStyles} from '@mui/styles';
import Card from '@mui/material/Card';
import List from "@mui/material/List";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Collapse from '@mui/material/Collapse';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import FileSaver from "file-saver";
import Avatar from "@mui/material/Avatar";
import baseMaleAvatar from "../../../images/male-icon.svg";
import baseFemaleAvatar from "../../../images/female-icon.svg";
import euroIcon from '../../../images/euro-icon.svg';
import pdfIcon from "../../../images/file-png-icon.png";
import addIcon from "../../../images/add.svg";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import exitIcon from "../../../images/exit-icon.svg";
import {useMediaQuery} from "react-responsive";
import Carousel from "react-multi-carousel";
import 'react-multi-carousel/lib/styles.css';
import CardContent from "@mui/material/CardContent";
import {useForm} from "react-hook-form";
import nothing from "../../../images/nothing-icon.svg";
import CurrencyFormat from 'react-currency-format';
import DialogDoubleAction from "../../components/DialogDoubleAction.js";
import baseCompanyAvatar from "../../../images/company-avatar.svg";
import {useTranslation} from "react-i18next";
import themeContext from "../../components/ThemeContext.js";
import ErrorPage from "../../pages/ErrorPage.js";
import {NavbarContext} from "../../middleware/NavbarContext.js";
import {SidebarContext} from "../../middleware/SidebarContext.js";
import {ExternalPageLayout, StyledPageCard, StyledPageLayout, StyledTitlePage} from "../../styles/DesktopStyles.js";
import {
    getDetailTypeFromParam,
    getDetailValueDoc,
    getPolicyRegulations,
    getRegulationThumbnail,
    updateRegulationDetail,
    uploadRegulationDoc
} from "../../service/RegulationsService.js";
import {
    calculateStatus,
    getBranchIcon,
    getPeopleImages,
    getPolicyDetail,
    getPolicyPeopleData
} from "../../service/DashboardService.js";
import trashIcon from "../../../images/desktop/trash-icon.svg";
import {styled} from "@mui/system";
import IconButton from "@mui/material/IconButton";

const useStyles = makeStyles((theme) => ({
    root: {
        width: '100% !important',
    },
    card: {
        margin: "0 auto !important",
        marginBottom: "18px !important",
        background: `${themeContext.color.white} 0% 0% no-repeat padding-box !important`,
        boxShadow: `2px 3px 10px ${themeContext.color.boxShadow} !important`,
        borderRadius: "10px !important",
        opacity: "1 !important",
        minHeight: "140px !important"
    },
    cardTextMid: {
        color: `${themeContext.color.neutral600} !important`,
        textAlign: 'left !important',
        lineHeight: '1 !important',
        fontWeight: '400 !important',
        fontSize: '12px !important',
        paddingTop: '10px !important',
        paddingBottom: '7px !important',
    },
    personAvatar: {
        width: "30px !important",
        height: "30px !important",
    },
    listItem: {
        width: "100% !important",
        fontSize: "14px !important",
        color: `${themeContext.color.neutral400} !important`,
        paddingTop: '18px !important',
        paddingBottom: '18px !important',
    },
    subtitle: {
        textAlign: "left !important",
        fontSize: "18px !important",
        fontStyle: "normal !important",
        lineHeight: "normal !important",
        fontWeight: "700 !important",
        color: `${themeContext.color.neutral400} !important`,
    },
    CTAButton: {
        fontWeight: '500 !important',
        fontSize: '14px !important',
        fontStyle: 'normal !important',
        lineHeight: 'normal !important',
        color: `${themeContext.color.mainActive} !important`,
        textTransform: 'uppercase !important',
        float: 'left !important',
        marginBottom: '8px !important'
    }
}));

const StyledTrashButton = styled(IconButton)(({theme}) => ({
    position: 'absolute',
    right: 0,
    top: 0
}));

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

export default function Regulations({layout}) {
    const {open} = useContext(SidebarContext);
    let defaultValues = {};
    const checkReadUrl = `${process.env.REACT_APP_BASE_URL}/notifications/notify/checkRead`;
    const token = sessionStorage.getItem('token');
    const policyToken = sessionStorage.getItem('policy_token');
    const [isLoadingData, setIsLoadingData] = useState(false);
    const [openUploadDialog, setOpenUploadDialog] = useState(false);
    const navigate = useNavigate();
    const hiddenFileInput = useRef(null);
    const [openNestedNotSigned, setOpenNestedNotSigned] = useState(0);
    const [images, setImages] = useState([]);
    const [documents, setDocuments] = useState([]);
    const [file, setFile] = useState(null);
    const formValues = useRef(defaultValues);
    const {sendControl, handleSubmit: handleSendSubmit} = useForm();
    const isDesktop = useMediaQuery({query: '(min-width: 768px)'})
    const {t, i18n} = useTranslation();
    const {toggleNavbar} = useContext(NavbarContext);


    useEffect(() => {
        toggleNavbar(true)
        sessionStorage.setItem('root', '/signing');
        if (navigator.onLine) {
            if (sessionStorage.getItem("notificationId") != null) {
                const url = sessionStorage.getItem("notificationId").replaceAll('"', '')
                navigateToMessageDetails(url);
            }
            handleRinging();
            getRegulations();
            setImages([])
        } else {
            //
        }
    }, []);

    const client = new ClientJS();
    const [bellRinging, setBellRinging] = useState(false);
    const classes = useStyles();
    let [people, setPeople] = useState([]);
    const [getPermission, setGetPermission] = useState(false);
    const [selectedRegulation, setSelectedRegulation] = useState(null);
    const [selectedParameterId, setSelectedParameterId] = useState(null);
    const [selectedParameter, setSelectedParameter] = useState(null);
    const [isDocumentPresent, setIsDocumentPresent] = useState(false);
    //const [serviceError, setServiceError] = useState(false);
    const [errorPage, setErrorPage] = useState(false);
    const [openDetailsDialog, setOpenDetailsDialog] = useState(false);
    const [openUploadConfirmDialog, setOpenUploadConfirmDialog] = useState(false);
    const [noRegulations, setNoRegulations] = useState(false);
    const [contentTypeError, setContentTypeError] = useState(false);

    if (((client.isMobileIOS() || isIpad()) && client.getOSVersion() < "16.4") || (isMac() && client.getOSVersion() < "13") || ((client.isMobileIOS() || isIpad()) && !(client.getOSVersion() < "16.4") && !isStandalone())) {
        console.log('notification not allowed')
    } else if (!getPermission) {
        requestPermission();
        setGetPermission(true);
    }
    fetchToken();

    function requestPermission() {
        Notification.requestPermission().then((permission) => {
            if (permission === 'granted') {
            }
        })
    }

    if (((client.isMobileIOS() || isIpad()) && client.getOSVersion() < "16.4") || (isMac() && client.getOSVersion() < "13") || ((client.isMobileIOS() || isIpad()) && !(client.getOSVersion() < "16.4") && !isStandalone())) {
        console.log('notification not allowed')
    } else {
        const channel = new BroadcastChannel('sw-messages');
        channel.onmessage = (event) => {
            setBellRinging(true)
        };
        channel.onmessageerror = (event) => {
        };
    }

    const navigateToMessageDetails = (url) => {
        return navigate(`/messages/principal/${url}`);
    }

    const handleRinging = () => {
        fetch(checkReadUrl, {
            method: 'GET', headers: {'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json',},
        }).then((response) => {
            return response.json();
        }).then((data) => {
            if (data.toRead) {
                setBellRinging(true);
            } else {
                setBellRinging(false);
            }
        }).catch(() => {
            setErrorPage(true)
        })
    }

    const getRegulations = () => {
        setIsLoadingData(true)
        getPolicyRegulations(policyToken).then((data) => {
            const regulations = data.data;
            const size = regulations.length;
            let count = 0;
            if(size === 0) {
                setNoRegulations(true)
                setIsLoadingData(false)
            }  else {
                getPolicyPeopleData(policyToken).then(async (res) => {
                    const data = res.data;
                    const ids = data.map((item) => ({id: item.id, personId: item.person_id}));
                    getPeopleImages(token, ids).then((imageData) => {
                        setPeople([])
                        data.map((item) => {
                            const imageInfo = imageData.find(image => image.id === item.id);
                            if (imageInfo) {
                                item.image = imageInfo.image !== "" ? imageInfo.image : null;
                                item.status = imageInfo.status;
                            }
                            item.regulations = [];
                            if(item.status !== 1) {
                                const regulationByHolder = regulations.filter((regulation) => regulation.policyholder_id === item.id);
                                item.regulations = regulationByHolder.map((regulation) => {
                                    let masked = false;
                                    getPolicyDetail(policyToken, regulation.policy_id).then((policyResult) => {
                                        regulation.policy = calculateStatus(policyResult.policy);
                                        regulation.details.map((detail, index) => {
                                            getDetailTypeFromParam(token, {param: detail.parameter}).then((result) => {
                                                detail.regulationType = result.message;
                                                if (regulation.filled_in_at !== null) {
                                                    switch (detail.regulationType) {
                                                        case 'money':
                                                            if (detail.value_money_final !== null) {
                                                                masked = true;
                                                            }
                                                            break;
                                                        case 'int':
                                                            if (detail.value_int_final !== null) {
                                                                masked = true;
                                                            }
                                                            break;
                                                        case 'doc':
                                                            if (detail.value_doc_final) {
                                                                masked = true;
                                                            }
                                                            break;
                                                        case 'money, doc':
                                                            if (detail.value_doc_final || detail.value_money_final !== null) {
                                                                masked = true;
                                                            }
                                                            break;
                                                        case 'int, doc':
                                                            if (detail.value_doc_final || detail.value_int_final !== null) {
                                                                masked = true;
                                                            }
                                                            break;
                                                    }
                                                }
                                                if (index + 1 === regulation.details.length) {
                                                    regulation['masked'] = masked === true;
                                                }
                                                count++;
                                                if(count === size) {
                                                    setIsLoadingData(false)
                                                }
                                            }).catch(() => {
                                                setErrorPage(true)
                                            })
                                        })
                                    }).catch(() => {
                                        setErrorPage(true)
                                    })
                                    return regulation;
                                })
                                if(item.regulations.length > 0) {
                                    setPeople((prev) => [...prev, item])
                                }
                            }
                        })
                    }).catch(() => {
                        setErrorPage(true)
                    })
                }).catch(() => {
                    setErrorPage(true)
                })
            }
        }).catch(() => {
            setErrorPage(true)
        })
    }

    function getThumbForDetails(regulation) {
        regulation.details.map(
            (detail) => {
                detail.thumbUrl = 'ND'
                detail.fileUrl = 'ND'
                if(detail.regulationType.includes('doc') && detail.value_doc_final) {
                    getThumbDocument(detail)
                } else {
                    setIsDocumentPresent(false)
                }
                return detail
            }
        )
        setSelectedRegulation(regulation)
        setOpenDetailsDialog(true)
    }

    function getThumbDocument(detail) {
        getDetailValueDoc(policyToken, detail.id).then((data) => {
            getRegulationThumbnail(token, detail.id).then((thumbnail) => {
                detail.thumbUrl = thumbnail.message
                detail.fileUrl = data.url
                setIsDocumentPresent(true)
            }).catch(() => {
                setErrorPage(true)
            })
        })
    }

    const submitForm = () => {
    }

    const handleInputChange = (e) => {
        const {name, value} = e.target;
        if(value !== 'doc' || !Object.keys(formValues.current).includes(name)) {
            formValues.current = {...formValues.current, [name]: value}
        }
    };

    const uploadRegulationDetail = (regulationDetails) => {
        setIsLoadingData(true)
        console.log(formValues.current)
        regulationDetails.forEach((item) => {
            let isDoc = false;
            let file;
            let contentType;
            const formData = new FormData();
            for (const [key, value] of Object.entries(formValues.current)) {
                if(key === item.id + item.parameter) {
                    let docFound = documents.find((element) => element.parameter === item.id + item.parameter)
                    if (docFound) {
                        isDoc = true;
                    }
                    switch (item.regulationType) {
                        case 'money':
                            item.value_money_final = value;
                            break;
                        case 'int':
                            item.value_int_final = value;
                            break;
                        case 'doc':
                            if (docFound) {
                                file =  base64toBlob(docFound.doc.split(',')[1], docFound.type)
                                contentType = docFound.type
                                formData.append('file', base64toBlob(docFound.doc.split(',')[1], docFound.type))
                            }
                            break;
                        case 'money, doc':
                            if (value !== 'doc') {
                                item.value_money_final = value;
                            }
                            if (docFound) {
                                file =  base64toBlob(docFound.doc.split(',')[1], docFound.type)
                                contentType = docFound.type
                                formData.append('file', base64toBlob(docFound.doc.split(',')[1], docFound.type))
                            }
                            break;
                        case 'int, doc':
                            if (value !== 'doc') {
                                item.value_int_final = value;
                            }
                            if (docFound) {
                                file =  base64toBlob(docFound.doc.split(',')[1], docFound.type)
                                contentType = docFound.type
                                formData.append('file', base64toBlob(docFound.doc.split(',')[1], docFound.type))
                            }
                            break;
                    }
                }
            }
            setIsLoadingData(false)
            if (isDoc) {
                uploadDocAndValues(policyToken, item, contentType, file)
            } else {
                updateRegulationDetail(policyToken, item.id, {
                    id: item.id,
                    note: item.note,
                    rate: item.rate,
                    value_int_advanced: item.value_int_advanced,
                    value_int_final: item.value_int_final,
                    value_money_advanced_cents: item.value_money_advanced_cents,
                    value_money_final_cents: item.value_money_final * 100,
                }).then(() => {
                    setPeople([]);
                    getRegulations();
                }).catch(() => {
                    setErrorPage(true)
                })
            }
        })
    }

    const uploadDocAndValues = (policyToken, item, contentType, file) => {
        uploadRegulationDoc(policyToken, item.id, contentType,file).then(() => {
            updateRegulationDetail(policyToken, item.id, {
                id: item.id,
                note: item.note,
                rate: item.rate,
                value_int_advanced: item.value_int_advanced,
                value_int_final: item.value_int_final,
                value_money_advanced_cents: item.value_money_advanced_cents,
                value_money_final_cents: item.value_money_final * 100,
            }).then(() => {
                setPeople([]);
                getRegulations();
            }).catch(() => {
                setErrorPage(true)
            })
        }).catch(() => {
            setErrorPage(true)
        })
    }

    function reload() {
        window.location.reload();
    }

    const handleClick = (index) => {
        if (openNestedNotSigned === index) {
            setOpenNestedNotSigned(-1)
        } else {
            setOpenNestedNotSigned(index)
        }
    }

    const setStatusColor = (policyStatus) => {
        switch (policyStatus) {
            case 1:
                return themeContext.color.neutral200;
            case 2:
                return themeContext.color.green;
            case 3:
                return themeContext.color.yellow;
            case 4:
                return themeContext.color.red;
        }
    }

    const handleClickFile = event => {
        hiddenFileInput.current.click();
    };

    const handleChange = (event, parameter) => {
        const fileUploaded = event.target.files[0];
        if (event.target.files[0]) {
            let name = event.target.files[0].name
            let type = event.target.files[0].type
            if (type !== undefined && (type === 'application/pdf' || type === 'image/png' || type === 'image/jpg' || type === 'image/jpeg')) {
                setContentTypeError(false)
                getBase64(fileUploaded).then(res => {
                    setFile(fileUploaded)
                    setIsDocumentPresent(true)
                    setImages(current => [...current, pdfIcon])
                    let doc = {
                        doc: res,
                        filename: name,
                        parameter: parameter,
                        type: type
                    }
                    setDocuments(current => [...current, doc])
                });
                handleFile(fileUploaded);
            } else {
                setContentTypeError(true)
            }
        }
    }

    const handleFile = (file) => {
        const formData = new FormData();
        formData.append('file', file);
    }

    async function getBase64(file) {
        return new Promise((resolve, reject) => {
            const reader = new FileReader()
            reader.readAsDataURL(file)
            reader.onload = () => {
                resolve(reader.result)
            }
            reader.onerror = reject
        })
    }

    return (
        <ExternalPageLayout open={open}>
            <StyledPageCard>
                {
                    errorPage ?
                        <ErrorPage/> :
                        <StyledPageLayout className="w-100 px-4" style={{background: themeContext.color.neutral10}}>
                            <StyledTitlePage>
                                <Col className="col-2 float-left"></Col>
                                <Col className="col-8">
                                    <span className="header-title ellipsis-1-v2">{t('regulations.title')}</span>
                                </Col>
                                <Col className="col float-right"></Col>
                            </StyledTitlePage>
                            <Row className="mt-2">
                                <Col className="col-list">
                                    {isLoadingData &&
                                        <div style={{'height': '85vh'}}
                                             className="background-loading-spinner"></div>
                                    }
                                </Col>
                                {!isLoadingData && noRegulations &&
                                    <div style={{
                                        margin: '10vh auto',
                                        backgroundColor: themeContext.color.neutral10
                                    }}>
                                        <Row>
                                            <Col>
                                                <img src={nothing} alt={t('signing.nothing-text-1')}></img>
                                            </Col>
                                        </Row>
                                        <Row className="mt-2">
                                            <Col>
                                                    <span
                                                        className="no-messages-text">{t('regulations.nothing-text-1')}</span>
                                            </Col>
                                        </Row>
                                    </div>
                                }
                                {!isLoadingData && !noRegulations &&
                                    <List
                                        component="nav"
                                        aria-labelledby="nested-list-subheader"
                                        className={classes.root}>
                                        {people.map((value, index) => (
                                            <Fragment key={index}>
                                                <ListItemButton onClick={() => handleClick(index)}
                                                                className={classes.listItem}>
                                                    <ListItemIcon>
                                                        {value.image === null && value.gender === 'M' &&
                                                            <Avatar className={classes.personAvatar}
                                                                    src={baseMaleAvatar}
                                                                    alt="avatar-image"/>}
                                                        {value.image === null && value.gender === 'F' &&
                                                            <Avatar className={classes.personAvatar}
                                                                    src={baseFemaleAvatar}
                                                                    alt="avatar-image"/>}
                                                        {value.image === null && value.gender === 'C' &&
                                                            <Avatar className={classes.personAvatar}
                                                                    src={baseCompanyAvatar}
                                                                    alt="avatar-image"/>}
                                                        {value.image === null && value.gender === null &&
                                                            <Avatar className={classes.personAvatar}
                                                                    src={baseMaleAvatar}
                                                                    alt="avatar-image"/>}
                                                        {value.image &&
                                                            <Avatar className={classes.personAvatar}
                                                                    src={value.image}
                                                                    alt="avatar-image"/>}
                                                    </ListItemIcon>
                                                    {((value.first_name === null || value.first_name === "") && (value.last_name === null || value.last_name === "")) ?
                                                        <ListItemText className="list-label"
                                                                      secondary={value.name.toLowerCase()}
                                                                      style={{
                                                                          textTransform: 'capitalize',
                                                                          color: themeContext.color.neutral600
                                                                      }}/> :
                                                        <ListItemText className="list-label"
                                                                      secondary={`${value.first_name.toLowerCase()} ${value.first_name.toLowerCase()}`}
                                                                      style={{
                                                                          textTransform: 'capitalize',
                                                                          color: themeContext.color.neutral600
                                                                      }}/>}
                                                    <span style={{
                                                        textAlign: 'right',
                                                        fontSize: '12px',
                                                        fontWeight: '700'
                                                    }}></span>
                                                    {openNestedNotSigned === index ? <ExpandMore/> :
                                                        <ExpandLess/>}
                                                </ListItemButton>
                                                <Collapse in={openNestedNotSigned === index} timeout="auto"
                                                          unmountOnExit>
                                                    <div>
                                                        <Row>
                                                            <List component="div"
                                                                  className="col div-under-list">
                                                                {value.regulations.map((regulation) => {
                                                                    return (
                                                                        <Fragment key={regulation.id}>
                                                                            <Card className={classes.card}
                                                                                  key={regulation.id}
                                                                                  style={{'borderRight': `12px solid ${setStatusColor(regulation?.policy?.status)}`}}>
                                                                                <CardContent
                                                                                    style={{'paddingBottom': '12px'}}>
                                                                                    <Row>
                                                                                        <Col
                                                                                            className="col-auto mr-0"
                                                                                            style={{'paddingRight': '0px'}}>
                                                                                            <img
                                                                                                src={getBranchIcon(regulation.branch_name)}
                                                                                                alt="type-policy-icon"/>
                                                                                        </Col>
                                                                                        <Col className="col-7">
                                                                                            <h6 className={classes.cardTextMid}>{regulation.branch_name}</h6>
                                                                                        </Col>
                                                                                    </Row>
                                                                                    <Row>
                                                                                        <Col>
                                                                                            <h6 className={"card-text-content ellipsis-1-v2"}>
                                                                                                {t('dashboard.expiration-label')}
                                                                                                <span
                                                                                                    className="font-weight-bold black">
                                                                                        {regulation.date_end}
                                                                                </span>
                                                                                            </h6>
                                                                                        </Col>
                                                                                    </Row>
                                                                                    <Row>
                                                                                        <Col>
                                                                                            <h6 className={"card-text-content ellipsis-1-v2"}>
                                                                                                {t('dashboard.company-label')}
                                                                                                <span
                                                                                                    className="font-weight-bold black">
                                                                                    {regulation.company_name}
                                                                                </span>
                                                                                            </h6>
                                                                                        </Col>
                                                                                    </Row>
                                                                                    <Row>
                                                                                        <Col>
                                                                                            <h6 className={"card-text-content ellipsis-1-v2"}>
                                                                                                {t('dashboard.policy-number-label')}
                                                                                                <span
                                                                                                    className="font-weight-bold black">
                                                                                    {regulation.policynr}
                                                                                </span>
                                                                                            </h6>
                                                                                        </Col>
                                                                                    </Row>
                                                                                    {regulation.masked === true &&
                                                                                        <Row>
                                                                                            <Col
                                                                                                className="div-masked">
                                                                                                {regulation.details.map((detail, index) => (
                                                                                                    detail.filledInAt !== null &&
                                                                                                    <Fragment
                                                                                                        key={index}>
                                                                                                        {
                                                                                                            index === 0 &&
                                                                                                            <Row>
                                                                                                                <Col>
                                                                                                                    <h6 className={"card-text-content ellipsis-1-v2"}
                                                                                                                        style={{
                                                                                                                            textAlign: 'center'
                                                                                                                        }}>
                                                                                                                        {t('regulations.updated-at-label')}
                                                                                                                            {regulation.filled_in_at}
                                                                                                                    </h6>
                                                                                                                </Col>
                                                                                                            </Row>
                                                                                                        }
                                                                                                        {
                                                                                                            (detail.regulationType === 'money' && detail.value_money_final !== null) &&
                                                                                                            <Fragment>
                                                                                                                <Row>
                                                                                                                    <Col>
                                                                                                                        <h6 className={"card-text-content ellipsis-1-v2"}>
                                                                                                                            {detail.parameter} {t('regulations.money-label')} {t('regulations.after-detailType-label')}
                                                                                                                            <span className="font-weight-bold black">{detail.value_money_final}</span>
                                                                                                                        </h6>
                                                                                                                    </Col>
                                                                                                                </Row>
                                                                                                                {
                                                                                                                    detail.note &&
                                                                                                                    <Row>
                                                                                                                        <Col>
                                                                                                                            <h6 className={"card-text-content ellipsis-1-v2"}
                                                                                                                                style={{
                                                                                                                                    'marginTop': '-8px',
                                                                                                                                    'paddingBottom': '8px'
                                                                                                                                }}>
                                                                                                                                {t('regulations.note')}
                                                                                                                                <span
                                                                                                                                    className="font-weight-bold black">
                                                                                                                            {detail.note}
                                                                                                                    </span>
                                                                                                                            </h6>
                                                                                                                        </Col>
                                                                                                                    </Row>
                                                                                                                }
                                                                                                            </Fragment>
                                                                                                        }
                                                                                                        {
                                                                                                            (detail.regulationType === 'int' && detail.value_int_final !== null) &&
                                                                                                            <Fragment>
                                                                                                                <Row>
                                                                                                                    <Col>
                                                                                                                        <h6 className={"card-text-content ellipsis-1-v2"}>
                                                                                                                            {detail.parameter} {t('regulations.after-detailType-label')}
                                                                                                                            <span
                                                                                                                                className="font-weight-bold black">
                                                                                                                        {detail.value_int_final}
                                                                                                            </span>
                                                                                                                        </h6>
                                                                                                                    </Col>
                                                                                                                </Row>
                                                                                                                {
                                                                                                                    detail.note &&
                                                                                                                    <Row>
                                                                                                                        <Col>
                                                                                                                            <h6 className={"card-text-content ellipsis-1-v2"}
                                                                                                                                style={{
                                                                                                                                    'marginTop': '-8px',
                                                                                                                                    'paddingBottom': '8px'
                                                                                                                                }}>
                                                                                                                                {t('regulations.note')}
                                                                                                                                <span
                                                                                                                                    className="font-weight-bold black">
                                                                                                                            {detail.note}
                                                                                                                    </span>
                                                                                                                            </h6>
                                                                                                                        </Col>
                                                                                                                    </Row>
                                                                                                                }
                                                                                                            </Fragment>
                                                                                                        }
                                                                                                        {
                                                                                                            detail.regulationType === 'doc' &&
                                                                                                            <Row>
                                                                                                                <Col>
                                                                                                                    <h6 className={"card-text-content ellipsis-1-v2"}>
                                                                                                                        {t('regulations.documents-label')}
                                                                                                                        <span
                                                                                                                            className="font-weight-bold black">{detail.value_doc_final === true ? 1 : 0}</span>
                                                                                                                    </h6>
                                                                                                                </Col>
                                                                                                            </Row>
                                                                                                        }
                                                                                                        {
                                                                                                            detail.regulationType === 'money, doc' &&
                                                                                                            <Fragment>
                                                                                                                {detail.value_money_final !== null &&
                                                                                                                    <Fragment>
                                                                                                                        <Row>
                                                                                                                            <Col>
                                                                                                                                <h6 className={"card-text-content ellipsis-1-v2"}>
                                                                                                                                    {detail.parameter} {t('regulations.money-label')} {t('regulations.after-detailType-label')}
                                                                                                                                    <span
                                                                                                                                        className="font-weight-bold black">
                                                                                                                            {detail.value_money_final}
                                                                                                                </span>
                                                                                                                                </h6>
                                                                                                                            </Col>
                                                                                                                        </Row>
                                                                                                                        {
                                                                                                                            detail.note &&
                                                                                                                            <Row>
                                                                                                                                <Col>
                                                                                                                                    <h6 className={"card-text-content ellipsis-1-v2"}
                                                                                                                                        style={{
                                                                                                                                            'marginTop': '-8px',
                                                                                                                                            'paddingBottom': '8px'
                                                                                                                                        }}>
                                                                                                                                        {t('regulations.note')}
                                                                                                                                        <span
                                                                                                                                            className="font-weight-bold black">
                                                                                                                            {detail.note}
                                                                                                                    </span>
                                                                                                                                    </h6>
                                                                                                                                </Col>
                                                                                                                            </Row>
                                                                                                                        }
                                                                                                                    </Fragment>
                                                                                                                }
                                                                                                                <Row>
                                                                                                                    <Col>
                                                                                                                        <h6 className={"card-text-content ellipsis-1-v2"}>
                                                                                                                            {t('regulations.documents-label')}
                                                                                                                            <span
                                                                                                                                className="font-weight-bold black">
                                                                                                                        {detail.value_doc_final === true ? 1 : 0}
                                                                                                            </span>
                                                                                                                        </h6>
                                                                                                                    </Col>
                                                                                                                </Row>
                                                                                                            </Fragment>
                                                                                                        }
                                                                                                        {
                                                                                                            detail.regulationType === 'int, doc' &&
                                                                                                            <Fragment>
                                                                                                                {detail.value_int_final &&
                                                                                                                    <Fragment>
                                                                                                                        <Row>
                                                                                                                            <Col>
                                                                                                                                <h6 className={"card-text-content ellipsis-1-v2"}>
                                                                                                                                    {detail.parameter} {t('regulations.after-detailType-label')}
                                                                                                                                    <span
                                                                                                                                        className="font-weight-bold black">
                                                                                                                        {detail.value_int_final}
                                                                                                                </span>
                                                                                                                                </h6>
                                                                                                                            </Col>
                                                                                                                        </Row>
                                                                                                                        {
                                                                                                                            detail.note &&
                                                                                                                            <Row>
                                                                                                                                <Col>
                                                                                                                                    <h6 className={"card-text-content ellipsis-1-v2"}
                                                                                                                                        style={{
                                                                                                                                            'marginTop': '-8px',
                                                                                                                                            'paddingBottom': '8px'
                                                                                                                                        }}>
                                                                                                                                        {t('regulations.note')}
                                                                                                                                        <span
                                                                                                                                            className="font-weight-bold black">
                                                                                                                            {detail.note}
                                                                                                                    </span>
                                                                                                                                    </h6>
                                                                                                                                </Col>
                                                                                                                            </Row>
                                                                                                                        }
                                                                                                                    </Fragment>
                                                                                                                }
                                                                                                                <Row>
                                                                                                                    <Col>
                                                                                                                        <h6 className={"card-text-content ellipsis-1-v2"}>
                                                                                                                            {t('regulations.documents-label')}
                                                                                                                            <span
                                                                                                                                className="font-weight-bold black">
                                                                                                                        {detail.value_doc_final === true ? 1 : 0}
                                                                                                            </span>
                                                                                                                        </h6>
                                                                                                                    </Col>
                                                                                                                </Row>
                                                                                                            </Fragment>
                                                                                                        }
                                                                                                    </Fragment>
                                                                                                ))}
                                                                                            </Col>
                                                                                        </Row>
                                                                                    }
                                                                                    <Row
                                                                                        className="float-right">
                                                                                        <Col>
                                                                                            <Button
                                                                                                style={{'marginTop': '0px'}}
                                                                                                onClick={() => {
                                                                                                    getThumbForDetails(regulation)
                                                                                                }}
                                                                                                className={classes.CTAButton}>{t('regulations.regulation-button')}
                                                                                            </Button>
                                                                                        </Col>
                                                                                    </Row>
                                                                                </CardContent>
                                                                            </Card>
                                                                        </Fragment>
                                                                    )
                                                                })
                                                                }
                                                            </List>

                                                        </Row>
                                                    </div>
                                                </Collapse>
                                            </Fragment>))
                                        }
                                    </List>
                                }
                            </Row>
                            { selectedRegulation &&
                                <Dialog
                                    onClose={() => {
                                        defaultValues = {}
                                        setImages([])
                                        setDocuments([])
                                        setOpenDetailsDialog(false)
                                    }}
                                    fullScreen={!isDesktop}
                                    fullWidth={isDesktop}
                                    maxWidth={'sm'}
                                    PaperProps={{
                                        style: {
                                            bottom: isDesktop ? '5%' : '0',
                                            color: themeContext.color.neutral600,
                                            borderTopLeftRadius: '20px',
                                            borderTopRightRadius: '20px',
                                            borderRadius: isDesktop ? '20px' : 'none',
                                            height: isDesktop ? '90%' : '100%',
                                            marginTop: '10%'
                                        }
                                    }}
                                    open={openDetailsDialog}
                                    TransitionComponent={Transition}
                                    aria-labelledby="alert-dialog-slide-title"
                                    aria-describedby="alert-dialog-slide-description">
                                    <DialogTitle id="alert-dialog-slide-title" className="dialog-title"
                                                 style={{textAlign: 'center'}}>
                                        <Row style={{justifyContent: 'end'}}>
                                            <img src={exitIcon} className="exit-button" alt="close" onClick={() => {
                                                defaultValues = {}
                                                setImages([])
                                                setDocuments([])
                                                setOpenDetailsDialog(false)
                                                setContentTypeError(false)
                                            }} style={{float: 'inline-end'}}/>
                                        </Row>
                                        <Row style={{marginTop: '-12px'}}>
                                            <Col className="col-1">
                                                <img className="align-baseline" src={getBranchIcon(selectedRegulation.branch_name)}
                                                     alt="type-policy-icon"/>
                                            </Col>
                                            <Col className="col-10">
                                                <h6 className="dialog-form-title-1 float-left">{selectedRegulation.branch_name}</h6>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col>
                                                <h6 className="dialog-form-title-2 float-left">{t('regulations.company-label')} {selectedRegulation.company_name}</h6>
                                            </Col>
                                        </Row>
                                        <Row className="mb-2">
                                            <Col>
                                                <h6 className="dialog-form-title-3 float-left">{t('regulations.expiration-label')}
                                                    <span className="dialog-form-title-3">{selectedRegulation.date_end}</span>
                                                </h6>
                                            </Col>
                                        </Row>
                                    </DialogTitle>
                                    <DialogContent className="no-scrollbar">
                                        <div className="dialog-main-container"
                                             style={{paddingBottom: "96px"}}>
                                            <Row>
                                                <Col>
                                                    <h6 className="dialog-form-field">
                                    <span className="ellipsis-1">
                                          {t('regulations.regulation-type')}
                                        <span className="dialog-form-value">
                                                  {selectedRegulation.type}
                                            </span>
                                    </span>
                                                    </h6>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col>
                                                    <h6 className="dialog-form-field ellipsis-1-v2">
                                                        {t('regulations.date-start')}
                                                        <span className="dialog-form-value">{selectedRegulation.date_start}</span>
                                                    </h6>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col>
                                                    <h6 className="dialog-form-field ellipsis-1-v2">
                                                        {t('regulations.date-end')}
                                                        <span className="dialog-form-value">{selectedRegulation.date_end}</span>
                                                    </h6>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col>
                                                    <h6 className="dialog-form-field ellipsis-1-v2">
                                                        {t('regulations.final-balance-days')}
                                                        <span className="dialog-form-value">{selectedRegulation.days_final}</span>
                                                    </h6>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col>
                                                    <h6 className="dialog-form-field ellipsis-1-v2">
                                                        {t('regulations.payment-days')}
                                                        <span className="dialog-form-value">
                                                  {selectedRegulation.days_payment}
                                            </span>
                                                    </h6>
                                                </Col>
                                            </Row>
                                            <Row style={{marginTop: '56px'}}>
                                                <Col>
                                                    <h6 className="dialog-form-subtitle ellipsis-1-v2">{t('regulations.regulation-section')}</h6>
                                                </Col>
                                            </Row>
                                            <Form onSubmit={handleSendSubmit(submitForm)} style={{marginBottom: '30px'}}>
                                                {
                                                    selectedRegulation?.details?.map((detail) => {
                                                        return (
                                                            <Fragment key={detail.id}>
                                                                <Row>
                                                                    <Col>
                                                                        <h6 className="dialog-parameter mt-4 text-capitalize">
                                                                            {detail.parameter.toLowerCase()}
                                                                        </h6>
                                                                        {
                                                                            detail.note !== null &&
                                                                            <h6 className="dialog-notes">
                                                                                <b>{t('regulations.note')}</b> {detail.note.toLowerCase()}
                                                                            </h6>
                                                                        }
                                                                        {
                                                                            detail.regulationType === 'money' &&
                                                                            <Fragment>
                                                                                <Row>
                                                                                    <Col>
                                                                                        <CurrencyFormat
                                                                                            customInput={TextField}
                                                                                            thousandSeparator={'.'}
                                                                                            decimalSeparator={','}
                                                                                            allowNegative={false}
                                                                                            onValueChange={(values) => {
                                                                                                const {
                                                                                                    formattedValue,
                                                                                                    value,
                                                                                                    floatValue
                                                                                                } = values;
                                                                                                formValues.current = {
                                                                                                    ...formValues.current,
                                                                                                    [`${detail.id}${detail.parameter}`]: floatValue
                                                                                                }
                                                                                            }}
                                                                                            id={`${detail.id}${detail.parameter}`}
                                                                                            autoComplete={'off'}
                                                                                            name={detail.id + detail.parameter}
                                                                                            placeholder=""
                                                                                            variant="outlined"
                                                                                            value={`${detail.value_money_final}`}
                                                                                            color="primary"
                                                                                            style={{
                                                                                                marginTop: '8px',
                                                                                                backgroundColor: themeContext.color.white,
                                                                                                width: '100%'
                                                                                            }}
                                                                                            InputProps={{
                                                                                                style: {
                                                                                                    borderRadius: '4px',
                                                                                                    color: themeContext.color.neutral600
                                                                                                },
                                                                                                endAdornment: (
                                                                                                    <InputAdornment
                                                                                                        position="end">
                                                                                                        <img src={euroIcon}
                                                                                                             alt="payments-icon"/>
                                                                                                    </InputAdornment>
                                                                                                )
                                                                                            }}
                                                                                        />
                                                                                    </Col>
                                                                                </Row>
                                                                                {detail.value_money_advanced !== null &&
                                                                                    <Row className="mt-1">
                                                                                        <Col>
                                                                                            <h6 className="dialog-textfield-label ellipsis-1-v2">
                                                                                                {t('regulations.advanced-value')}
                                                                                                <b>
                                                                                                        {detail.value_money_advanced}
                                                                                                </b>
                                                                                            </h6>
                                                                                        </Col>
                                                                                    </Row>
                                                                                }
                                                                            </Fragment>
                                                                        }
                                                                        {
                                                                            detail.regulationType === 'int' &&
                                                                            <Fragment>
                                                                                <Row>
                                                                                    <Col>
                                                                                        <TextField
                                                                                            onKeyPress={(event) => {
                                                                                                if (!/[0-9]/.test(event.key)) {
                                                                                                    event.preventDefault();
                                                                                                }
                                                                                            }}
                                                                                            onChange={handleInputChange}
                                                                                            id={`${detail.id}${detail.parameter}`}
                                                                                            autoComplete={'off'}
                                                                                            name={detail.id + detail.parameter}
                                                                                            fullWidth
                                                                                            placeholder=""
                                                                                            variant="outlined"
                                                                                            type="number"
                                                                                            defaultValue={detail.value_int_final}
                                                                                            color="primary"
                                                                                            InputProps={{
                                                                                                inputProps: {min: 0},
                                                                                                style: {
                                                                                                    'borderRadius': '4px',
                                                                                                    'color': themeContext.color.neutral600
                                                                                                }
                                                                                            }}
                                                                                        />
                                                                                    </Col>
                                                                                </Row>
                                                                                {detail.value_int_advanced !== null &&
                                                                                    <Row className="mt-1">
                                                                                        <Col>
                                                                                            <h6 className="dialog-textfield-label ellipsis-1-v2">
                                                                                                {t('regulations.advanced-value')}<b>{detail.value_int_advanced}</b>
                                                                                            </h6>
                                                                                        </Col>
                                                                                    </Row>
                                                                                }
                                                                            </Fragment>
                                                                        }
                                                                        {
                                                                            detail.regulationType === 'doc' &&
                                                                            <Fragment>
                                                                                {
                                                                                    detail.thumbUrl !== 'ND' &&
                                                                                    <Fragment>
                                                                                        <Row>
                                                                                            <Col>
                                                                                                <img alt="thumb-pdf"
                                                                                                     className="thumb-pdf"
                                                                                                     src={detail.thumbUrl}
                                                                                                     onClick={() => {
                                                                                                         window.open(detail.fileUrl, '_blank', 'noopener,noreferrer');
                                                                                                     }}/>
                                                                                            </Col>
                                                                                        </Row>
                                                                                    </Fragment>
                                                                                }
                                                                                <Row className="mt-4">
                                                                                    <Col style={{textAlign: 'center'}}>
                                                                                        <Button
                                                                                            className="outline-button"
                                                                                            onClick={() => {
                                                                                                setSelectedParameterId(detail.id + detail.parameter)
                                                                                                setSelectedParameter(detail.parameter)
                                                                                                let docFinded = documents.findIndex((item) => item.parameter === detail.id + detail.parameter)
                                                                                                if (docFinded !== -1)
                                                                                                    setImages(current => [...current, pdfIcon])
                                                                                                else {
                                                                                                    setImages([])
                                                                                                }
                                                                                                setOpenUploadDialog(true)
                                                                                            }}
                                                                                            variant="outlined"
                                                                                            size="large"
                                                                                            type="submit"
                                                                                            style={isDesktop ? {width: '300px'} : {width: '100%'}}
                                                                                        >{t('regulations.upload-button')}
                                                                                        </Button>
                                                                                    </Col>
                                                                                </Row>
                                                                            </Fragment>
                                                                        }
                                                                        {
                                                                            detail.regulationType === 'money, doc' &&
                                                                            <Fragment>
                                                                                <Row>
                                                                                    <Col>
                                                                                        <CurrencyFormat
                                                                                            customInput={TextField}
                                                                                            thousandSeparator={'.'}
                                                                                            decimalSeparator={','}
                                                                                            allowNegative={false}
                                                                                            onValueChange={(values) => {
                                                                                                const {
                                                                                                    formattedValue,
                                                                                                    value,
                                                                                                    floatValue
                                                                                                } = values;
                                                                                                formValues.current = {
                                                                                                    ...formValues.current,
                                                                                                    [`${detail.id}${detail.parameter}`]: floatValue
                                                                                                }
                                                                                            }}
                                                                                            id={`${detail.id}${detail.parameter}`}
                                                                                            autoComplete={'off'}
                                                                                            name={detail.id + detail.parameter}
                                                                                            placeholder=""
                                                                                            variant="outlined"
                                                                                            value={`${detail.value_money_final}`}
                                                                                            color="primary"
                                                                                            style={{
                                                                                                marginTop: '8px',
                                                                                                backgroundColor: themeContext.color.white,
                                                                                                width: '100%'
                                                                                            }}
                                                                                            InputProps={{
                                                                                                style: {
                                                                                                    borderRadius: '4px',
                                                                                                    color: themeContext.color.neutral600
                                                                                                },
                                                                                                endAdornment: (
                                                                                                    <InputAdornment
                                                                                                        position="end">
                                                                                                        <img src={euroIcon}
                                                                                                             alt="payments-icon"/>
                                                                                                    </InputAdornment>
                                                                                                )
                                                                                            }}
                                                                                        />
                                                                                    </Col>
                                                                                </Row>
                                                                                {detail.value_money_advanced !== null &&
                                                                                    <Row className="mt-1">
                                                                                        <Col>
                                                                                            <h6 className="dialog-textfield-label ellipsis-1-v2">
                                                                                                {t('regulations.advanced-value')}
                                                                                                <b>
                                                                                                        {detail.value_money_advanced}
                                                                                                </b>
                                                                                            </h6>
                                                                                        </Col>
                                                                                    </Row>
                                                                                }
                                                                                {
                                                                                    detail.thumbUrl !== 'ND' &&
                                                                                    <Fragment>
                                                                                        <Row>
                                                                                            <Col>
                                                                                                <img alt="thumb-pdf"
                                                                                                     className="thumb-pdf"
                                                                                                     src={detail.thumbUrl}
                                                                                                     onClick={() => {
                                                                                                         window.open(detail.fileUrl, '_blank', 'noopener,noreferrer');
                                                                                                     }}/>
                                                                                            </Col>
                                                                                        </Row>
                                                                                    </Fragment>
                                                                                }
                                                                                <Row className="mt-4">
                                                                                    <Col style={{textAlign: 'center'}}>
                                                                                        <Button
                                                                                            className="outline-button"
                                                                                            onClick={() => {
                                                                                                setSelectedParameterId(detail.id + detail.parameter)
                                                                                                setSelectedParameter(detail.parameter)
                                                                                                let docFinded = documents.findIndex((item) => item.parameter === detail.id + detail.parameter)
                                                                                                if (docFinded !== -1)
                                                                                                    setImages(current => [...current, pdfIcon])
                                                                                                else {
                                                                                                    setImages([])
                                                                                                }
                                                                                                setOpenUploadDialog(true)
                                                                                            }}
                                                                                            variant="outlined"
                                                                                            size="large"
                                                                                            type="submit"
                                                                                            style={isDesktop ? {width: '100%'} : {maxWidth: '300px'}}
                                                                                        >{t('regulations.upload-button')}
                                                                                        </Button>
                                                                                    </Col>
                                                                                </Row>
                                                                            </Fragment>
                                                                        }
                                                                        {
                                                                            detail.regulationType === 'int, doc' &&
                                                                            <Fragment>
                                                                                <Row>
                                                                                    <Col>
                                                                                        <TextField
                                                                                            onKeyPress={(event) => {
                                                                                                if (!/[0-9]/.test(event.key)) {
                                                                                                    event.preventDefault();
                                                                                                }
                                                                                            }}
                                                                                            onChange={handleInputChange}
                                                                                            id={`${detail.id}${detail.parameter}`}
                                                                                            autoComplete={'off'}
                                                                                            name={detail.id + detail.parameter}
                                                                                            fullWidth
                                                                                            placeholder=""
                                                                                            variant="outlined"
                                                                                            type="number"
                                                                                            defaultValue={detail.value_int_final}
                                                                                            color="primary"
                                                                                            InputProps={{
                                                                                                inputProps: {min: 0},
                                                                                                style: {
                                                                                                    'borderRadius': '4px',
                                                                                                    'color': themeContext.color.neutral600
                                                                                                }
                                                                                            }}
                                                                                        />
                                                                                    </Col>
                                                                                </Row>
                                                                                {detail.value_int_advanced !== null &&
                                                                                    <Row className="mt-1">
                                                                                        <Col>
                                                                                            <h6 className="dialog-textfield-label ellipsis-1-v2">
                                                                                                {t('regulations.advanced-value')}<b>{detail.value_int_advanced}</b>
                                                                                            </h6>
                                                                                        </Col>
                                                                                    </Row>
                                                                                }
                                                                                {
                                                                                    detail.thumbUrl !== 'ND' &&
                                                                                    <div className="container ml-2 mt-2"
                                                                                         style={{
                                                                                             position: 'relative',
                                                                                             textAlign: 'left',
                                                                                             padding: '0'
                                                                                         }}>
                                                                                        <img alt="thumb-pdf"
                                                                                             className="thumb-pdf"
                                                                                             src={detail.thumbUrl}
                                                                                             onClick={() => {
                                                                                                 window.open(detail.fileUrl, '_blank', 'noopener,noreferrer');
                                                                                             }}/>
                                                                                    </div>
                                                                                }
                                                                                <Row className="mt-4">
                                                                                    <Col style={{textAlign: 'center'}}>
                                                                                        <Button
                                                                                            className="outline-button"
                                                                                            onClick={() => {
                                                                                                setSelectedParameterId(detail.id + detail.parameter)
                                                                                                setSelectedParameter(detail.parameter)
                                                                                                let docFinded = documents.findIndex((item) => item.parameter === detail.id + detail.parameter)
                                                                                                if (docFinded !== -1)
                                                                                                    setImages(current => [...current, pdfIcon])
                                                                                                else {
                                                                                                    setImages([])
                                                                                                }
                                                                                                setOpenUploadDialog(true)
                                                                                            }}
                                                                                            variant="outlined"
                                                                                            size="large"
                                                                                            type="submit"
                                                                                            style={isDesktop ? {width: '100%'} : {maxWidth: '300px'}}
                                                                                        >{t('regulations.upload-button')}
                                                                                        </Button>
                                                                                    </Col>
                                                                                </Row>
                                                                            </Fragment>
                                                                        }
                                                                    </Col>
                                                                </Row>
                                                            </Fragment>
                                                        )
                                                    })}
                                            </Form>
                                            <Container className="position-absolute"
                                                       style={
                                                           isDesktop ? {
                                                               background: 'transparent',
                                                               opacity: '1',
                                                               left: 0,
                                                               bottom: 48,
                                                               right: 0
                                                           } : {
                                                               background: 'transparent',
                                                               opacity: '1',
                                                               left: 0,
                                                               bottom: 68,
                                                               right: 0
                                                           }
                                                       }>
                                                <Row style={{textAlign: 'center'}}>
                                                    <Col>
                                                        <Button className="close-button boxShadow"
                                                                variant="outlined"
                                                                size="large"
                                                                style={{
                                                                    color: themeContext.color.white,
                                                                    width: '288px',
                                                                    textTransform: 'none'
                                                                }}
                                                                type="submit"
                                                                disabled={false}
                                                                onClick={() => {
                                                                    if (!isDocumentPresent) {
                                                                        uploadRegulationDetail(selectedRegulation.details)
                                                                        setOpenDetailsDialog(false)
                                                                        setImages([])
                                                                        setDocuments([])
                                                                        formValues.current = {}
                                                                        setImages([])
                                                                    } else {
                                                                        setOpenUploadConfirmDialog(true)
                                                                    }
                                                                }}
                                                        >{t('regulations.save-and-close-button')}</Button>
                                                    </Col>
                                                </Row>
                                            </Container>
                                        </div>
                                    </DialogContent>
                                </Dialog>
                            }
                            <Dialog
                                onClose={() => {
                                    setOpenUploadDialog(false)
                                    setImages([])
                                }}
                                fullScreen={!isDesktop}
                                fullWidth={isDesktop}
                                maxWidth={'sm'}
                                PaperProps={{
                                    style: {
                                        bottom: isDesktop ? '5%' : '0',
                                        color: themeContext.color.neutral600,
                                        borderTopLeftRadius: '20px',
                                        borderTopRightRadius: '20px',
                                        borderRadius: isDesktop ? '20px' : 'none',
                                        height: isDesktop ? '90%' : '100%',
                                        marginTop: '10%'
                                    }
                                }}
                                open={openUploadDialog}
                                TransitionComponent={Transition}
                                aria-labelledby="alert-dialog-slide-title"
                                aria-describedby="alert-dialog-slide-description">


                                <DialogTitle id="alert-dialog-slide-title" className="dialog-title ellipsis-1-v2"
                                             style={{textAlign: 'center'}}>
                                    <Row style={{justifyContent: 'end'}}>
                                        <img src={exitIcon} className="exit-button" alt="close" onClick={() => {
                                            setOpenUploadDialog(false)
                                            setImages([])
                                            setContentTypeError(false)
                                        }} style={{float: 'inline-end'}}/>
                                    </Row>
                                    <Row style={{marginTop: '-12px'}}>
                                        <Col className="col">
                                            <h6 className="dialog-form-title-1 ellipsis-1-v2 float-left text-left">{selectedParameter}</h6>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col>
                                            <h6 className="dialog-form-title-2 ellipsis-1-v2 float-left text-left">
                                                {t('regulations.pdf-dialog-title')}
                                            </h6>
                                        </Col>
                                    </Row>
                                    <Row className="mb-2">
                                        <Col>
                                            <h6 className="dialog-form-title-3 ellipsis-1-v2 float-left">
                                                {t('regulations.pdf-dialog-subtitle')}
                                            </h6>
                                        </Col>
                                    </Row>
                                </DialogTitle>
                                <DialogContent className="no-scrollbar">
                                    <div className="dialog-main-container">
                                        <Row className="mt-4">
                                            <Col>
                                                <Button
                                                    className={images.length !== 1 ? 'add-icon' : 'add-active-icon add-icon'} onClick={() => handleClickFile()}
                                                    disabled={images.length > 0}
                                                    style={{marginBottom: 16}}>
                                                    <div>
                                                        <input id="file" type="file"
                                                               onChange={event => handleChange(event, selectedParameterId)}
                                                               ref={hiddenFileInput}
                                                               style={{display: 'none'}}/>
                                                    </div>
                                                    <img
                                                        src={addIcon}
                                                        alt="First Thumbnail"
                                                    />
                                                </Button>

                                                {images.length > 0 &&
                                                    <Carousel
                                                        swipeable={false}
                                                        draggable={false}
                                                        responsive={{
                                                            mobile: {
                                                                breakpoint: {max: 4000, min: 0},
                                                                items: 5
                                                            }
                                                        }}
                                                        ssr={true} // means to render carousel on server-side.
                                                        infinite={false}
                                                        keyBoardControl={true}
                                                        customTransition="all .5"
                                                        transitionDuration={500}
                                                        containerClass="carousel-container"
                                                        dotListClass="custom-dot-list-style"
                                                        itemClass="carousel-style-custom">
                                                        {documents.map((item, index) => (
                                                            <div key={index}>
                                                                <IconButton
                                                                className={'image-fit'}
                                                                onClick={() => {
                                                                    if (item.doc) {
                                                                        FileSaver.saveAs(file, item.filename);
                                                                    }
                                                                }}>
                                                                    <img src={pdfIcon}
                                                                         className={'image-fit'}
                                                                         height="247px"
                                                                         width="182px"
                                                                         alt={`claim_${index}`}/>
                                                                </IconButton>
                                                                <StyledTrashButton color="error"
                                                                                   onClick={() => {
                                                                                       setDocuments([])
                                                                                       setImages([])
                                                                                       delete formValues.current[selectedParameterId]
                                                                                   }}>
                                                                    <img src={trashIcon} alt="trash-icon"/>
                                                                </StyledTrashButton>
                                                            </div>
                                                        ))}
                                                    </Carousel>
                                                }
                                            </Col>
                                        </Row>
                                        {
                                            contentTypeError &&
                                            <Row className="ml-4 mr-4 mt-4">
                                                <Col className="mt-4 text-center dialog-form-title-3 red">
                                                    {t('regulations.content-type-error')}
                                                </Col>
                                            </Row>
                                        }
                                        <Container className="position-absolute"
                                                   style={
                                                       isDesktop ? {
                                                           background: 'transparent',
                                                           opacity: '1',
                                                           left: 0,
                                                           bottom: 48,
                                                           right: 0
                                                       } : {
                                                           background: 'transparent',
                                                           opacity: '1',
                                                           left: 0,
                                                           bottom: 68,
                                                           right: 0
                                                       }
                                                   }>
                                            <Row style={{textAlign: 'center'}}>
                                                <Col>
                                                    <Button className="close-button boxShadow"
                                                            variant="outlined"
                                                            size="large"
                                                            style={{
                                                                color: themeContext.color.white,
                                                                width: '288px',
                                                                textTransform: 'none'
                                                            }}
                                                            type="submit"
                                                            disabled={false}
                                                            onClick={() => {
                                                                setImages([])
                                                                setOpenUploadDialog(false)
                                                            }}
                                                    >{t('regulations.save-pdf-button')}</Button>
                                                </Col>
                                            </Row>
                                        </Container>
                                    </div>
                                </DialogContent>
                            </Dialog>
                            <DialogDoubleAction open={openUploadConfirmDialog}
                                                title={t('regulations.regulation-confirm-title')}
                                                description={t('regulations.regulation-confirm-description')}
                                                handleClose={() => setOpenUploadConfirmDialog(false)}
                                                handleNo={() => setOpenUploadConfirmDialog(false)}
                                                handleYes={() => {
                                                    uploadRegulationDetail(selectedRegulation.details)
                                                    setOpenDetailsDialog(false)
                                                    setOpenUploadConfirmDialog(false)
                                                    setImages([])
                                                    setDocuments([])
                                                    formValues.current = {}
                                                    setImages([])
                                                    setIsDocumentPresent(false)
                                                }}
                                                buttonYesText={t('dialog.button-proceed')}
                                                buttonNoText={t('dialog.button-cancel')}/>
                        </StyledPageLayout>
                }
            </StyledPageCard>
        </ExternalPageLayout>
    )
}
